function MainContentView(header, clientConfiguration) {
    var currentView;
    var self = this;

    var $content = $("#content");
    var $parentPage = $content.closest("[data-role=page]");

    $parentPage.append(header.getContent());

    var views = [];
    var viewCount = 0;
    var firstShow = true;

    this.getViews = function() {
        return views;
    };

    this.getCurrentView = function() {
        return currentView;
    };

    this.getContent = function() {
        return $content;
    };

    this.setView = function(view) {
        // Get header config from view and update header accordingly
        header.configure(view.getHeaderConfiguration());

        view.show();
        currentView = view;

        var index = views.indexOf(view);

        if (index >= 0) {
            var slickIndex = 0;

            var slick = $content.slick("getSlick");
            $(slick.$slides).each(function(idx) {
                if ($(this).attr("data-view-id") == index) {
                    slickIndex = idx;
                }
            });

            if (firstShow) {
                // Slick has issues with animations and initial setup, so
                // we need to leave the animation enabled but set the speed to 0.
                //
                // see https://github.com/kenwheeler/slick/issues/396
                var origSpeed = $content.slick("slickGetOption", "speed");
                $content.slick("slickSetOption", "speed", 0);
                $content.slick("slickGoTo", slickIndex);
                $content.slick("slickSetOption", "speed", origSpeed);
            } else {
                $content.slick("slickGoTo", slickIndex);
            }
        }
        firstShow = false;
    };

    this.addView = function(view) {
        const weight = view.getWeight();
        var idx = 0;

        // Insert this view in the correct place in the views array
        for (; idx < viewCount; idx++) {
            if (views[idx].getWeight() > weight) {
                break;
            }
        }
        viewCount++;
        views.splice(idx, 0, view);

        // Remove all the views from $content
        for (var i = 0; i < viewCount; i++) {
            const viewId = views[i].getContent().attr("data-view-id");
            $content.detach("[data-view-id='" + viewId + "']");
        }

        // Add in all the views in the new order
        for (var viewIdx = 0; viewIdx < viewCount; viewIdx++) {
            const viewContent = views[viewIdx].getContent();
            viewContent.attr("data-view-id", viewIdx);
            $content.append(viewContent);
        }
    };

    this.show = function() {
        if (currentView) {
            currentView.show();
        }

        header.show();
        $content.show();

        views.forEach(function(view) {
            view.resize($content.innerWidth(), $content.innerHeight() - header.getContent().outerHeight());
        });
    };

    this.hide = function() {
        header.hide();
        $content.hide();
    };

    this.resize = function(width, height) {
        header.resize(width);
        views.forEach(function(view) {
            view.resize(width, height - header.getContent().outerHeight());
        });
    };

    $(document).on("reInit", function(event, slick) {
        var $slickDots = $(".slick-dots");
        $slickDots.addClass("header").appendTo(header.getContent());

        $slickDots.toggleClass("non-touch", !clientConfiguration.isTouch());
        var $lis = $slickDots.find("li");

        slick.$slides.each(function(i, slide) {
            var $li = $($lis[i]);
            $li.addClass($(slide).attr("data-nav-icon-class"));

            var view = views[$(slide).attr("data-view-id")];

            if (!clientConfiguration.isTouch()) {
                $li.find("button").after(view.getHeaderConfiguration().title);
            }
        });

        if (currentView) {
            header.configure(currentView.getHeaderConfiguration());
        }
    });

    $(document).on("userauthenticated", function() {
        firstShow = true;
    });

    $(document).on("loadappmodules", function() {
        $(document).on("resourceslistchange", function() {
            $content.find(".pullToRefresh").each(function() {
                var pullToRefreshContainers = $(this).data("plugin_xpull");

                if (pullToRefreshContainers) {
                    pullToRefreshContainers.reset();
                }
            });
        });
    });

    $parentPage.on("pagecreate", function() {
        // Set up swipe navigation
        $content.slick({
            dots : true,
            infinite : false,
            arrows : false,
            speed : 500,
            slidesToShow : 1,
            slidesToScroll : 1
        });

        $content.on("beforeChange", function(event, slick, currentPage, nextPage) {
            var $contentDiv = $(slick.$slides[nextPage]);
            var view = views[$contentDiv.attr("data-view-id")];

            if (currentView !== view) {
                CudaLaunch.controllers.RootController.showView(view);
            }
        });

        // Make sure the content is hidden on startup
        self.hide();
    });
}

module.exports = MainContentView;


//////////////////
// WEBPACK FOOTER
// ./common/MainContentView.js
// module id = 3
// module chunks = 3 4